





















































import { ModificationHistory } from "../../models/ModificationHistory";

export default {
    name: "HistoryRow",
    props: {
        row: ModificationHistory,
    },
    data() {
        return {
            EAction: ModificationHistory.EAction,
            Field: ModificationHistory.Field,
        };
    },
};
